import { useQuery } from "@tanstack/react-query";
import { EPromotionsAPI } from "../api";
import { LOCAL_STORAGE_USER } from "../utils/customConfig";

const fetchData = () => {
    return EPromotionsAPI.get({ params: { sellerId: LOCAL_STORAGE_USER?.id } });
};

export const useFetchPromotions = () => {
    return useQuery({
        queryKey: ["products"],
        queryFn: fetchData,
        keepPreviousData: true, // smooth switching
    });
};
